export default "__VITE_ASSET__CzBkE16b__"